import React, { useEffect, useState } from "react";
import LayoutBackOffice from "../../components/LayoutBackOffice";
import { AiFillProduct } from "react-icons/ai";
import { MdCategory } from "react-icons/md";
import { BsStars } from "react-icons/bs";

import { NavLink } from "react-router";
import { ThreeDots } from "react-loader-spinner";
import { Skeleton } from "@mui/material";
// import { formatAmountPrice } from "../../utils/MoneyFormatter";
import { statsDashboard } from "../../services/stats/StatsRequest";
import { FaUsers } from "react-icons/fa";
import { IoFlash } from "react-icons/io5";
import { TbBrandAppleFilled } from "react-icons/tb";

const DashboardBackoffice = () => {
  const [listeDonneeStatsBasic, setListeDonneeStatsBasic] = useState([]);
  const [loadingDataBasic, setLoadingDataBasic] = useState(false);

  const getStats = () => {
    setLoadingDataBasic(true);

    statsDashboard()
      .then((res) => {
        setLoadingDataBasic(false);
        console.log(res);
        setListeDonneeStatsBasic(res.data.data);
        console.log(res);
      })
      .catch((err) => {
        setLoadingDataBasic(false);

        console.log(err);
      });
  };

  useEffect(() => {
    getStats();
  }, []);

  return (
    <LayoutBackOffice>
      <div className="w-full h-full pt-5 pb-16 px-6">
        <div className="w-full">
          <h1 className="text-2xl md:text-3xl font-extrabold">
            Tableau de bord
          </h1>
          <p className="mt-2 text-gray-500 font-medium text-md sm:text-base md:text-2xl">
            Statistiques et bilan des données
          </p>
        </div>

        {/* STATISTIQUES */}
        <div className="mt-10 grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          <div className="bg-white w-full h-20 border shadow-lg rounded-xl flex items-center justify-start gap-3 px-3">
            <div className="w-full">
              <div className="flex flex-row justify-between items-center  w-full">
                <h3 className="text-gray-400 text-md font-medium">
                  Nombres de produit
                </h3>
                <AiFillProduct />
              </div>

              <span className="font-extrabold text-black text-2xl">
                {loadingDataBasic ? (
                  <Skeleton height={20} width={60} />
                ) : listeDonneeStatsBasic && listeDonneeStatsBasic.produits ? (
                  listeDonneeStatsBasic.produits.total
                ) : (
                  0
                )}
              </span>
            </div>
          </div>
          <div className="bg-white w-full h-20 border shadow-lg rounded-xl flex items-center justify-start gap-3 px-3">
            <div className="w-full">
              <div className="flex flex-row justify-between items-center  w-full">
                <h3 className="text-gray-400 text-md font-medium">
                  Produits vedettes
                </h3>
                <BsStars />
              </div>
              <span className="font-extrabold text-black text-2xl">
                {loadingDataBasic ? (
                  <Skeleton height={20} width={60} />
                ) : listeDonneeStatsBasic && listeDonneeStatsBasic.produits ? (
                  listeDonneeStatsBasic.produits.produitVedette
                ) : (
                  0
                )}
              </span>
            </div>
          </div>
          <div className="bg-white w-full h-20 border shadow-lg rounded-xl flex items-center justify-start gap-3 px-3">
            <div className="w-full">
              <div className="flex flex-row justify-between items-center  w-full">
                <h3 className="text-gray-400 text-md font-medium">
                  Produits en promo flash
                </h3>
                <IoFlash />
              </div>
              <span className="font-extrabold text-black text-2xl">
                {loadingDataBasic ? (
                  <Skeleton height={20} width={60} />
                ) : listeDonneeStatsBasic && listeDonneeStatsBasic.produits ? (
                  listeDonneeStatsBasic.produits.flashPromotions
                ) : (
                  0
                )}
              </span>
            </div>
          </div>
          <div className="bg-white w-full h-20 border shadow-lg rounded-xl flex items-center justify-start gap-3 px-3">
            <div className=" w-full">
              <div className="flex flex-row justify-between items-center  w-full">
                <h3 className="text-gray-400 text-md font-medium">
                  Comptes client
                </h3>

                <FaUsers />
              </div>
              <span className="font-extrabold text-black text-2xl">
                {loadingDataBasic ? (
                  <Skeleton height={20} width={60} />
                ) : (
                  listeDonneeStatsBasic && listeDonneeStatsBasic.visiteurs
                )}
              </span>
            </div>
          </div>
          <div className="bg-white w-full h-20 border shadow-lg rounded-xl flex items-center justify-start gap-3 px-3">
            <div className="w-full">
              <div className="flex flex-row justify-between items-center  w-full">
                <h3 className="text-gray-400 text-md font-medium">
                  Nombre de categorie
                </h3>
                <MdCategory />
              </div>
              <span className="font-extrabold text-black text-2xl">
                {loadingDataBasic ? (
                  <Skeleton height={20} width={60} />
                ) : (
                  listeDonneeStatsBasic && listeDonneeStatsBasic.categories
                )}
              </span>
            </div>
          </div>
          <div className="bg-white w-full h-20 border shadow-lg rounded-xl flex items-center justify-start gap-3 px-3">
            <div className="w-full">
              <div className="flex flex-row justify-between items-center  w-full">
                <h3 className="text-gray-400 text-md font-medium">
                  Nombre marque
                </h3>
                <TbBrandAppleFilled />
              </div>

              <span className="font-extrabold text-black text-2xl">
                {loadingDataBasic ? (
                  <Skeleton height={20} width={60} />
                ) : (
                  listeDonneeStatsBasic && listeDonneeStatsBasic.marques
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </LayoutBackOffice>
  );
};

export default DashboardBackoffice;
